function b(e) {
  const n = "Got invalid eventString parameter in ek-google-analytics.eventStringToObject(eventString). Given event has to be a comma separated String representing a Google Analytics event like 'eventCategory,eventAction,eventLabel,eventValue'";
  if (typeof e != "string")
    throw new Error(n);
  const t = e.split(",");
  if (t.length < 2)
    throw new Error(n);
  return {
    eventCategory: t[0],
    // Required by google.
    eventAction: t[1],
    // Required by google.
    eventLabel: t[2] || void 0,
    eventValue: t[3] || void 0
  };
}
function h({
  data: e,
  location: n,
  dimensions: t
}) {
  if (typeof e != "string")
    throw new Error(
      "Got invalid trackingObject from localstorage in ek-google-analytics"
    );
  const o = b(e);
  return {
    hitType: "event",
    location: n || window.location.origin + window.location.pathname,
    ...o,
    ...t
  };
}
function m(e) {
  return e ? typeof e.eventCategory == "string" && typeof e.eventAction == "string" : !1;
}
const k = /* @__PURE__ */ new Map([
  ["dimension1", "page_type"],
  ["dimension2", "l1_category_id"],
  ["dimension3", "l2_category_id"],
  ["dimension4", "l3_category_id"],
  ["dimension6", "l1_location_id"],
  ["dimension8", "l3_location_id"],
  ["dimension7", "l2_location_id"],
  ["dimension9", "l4_location_id"],
  ["dimension10", "selected_category_id"],
  ["dimension11", "selected_category_name"],
  ["dimension12", "selected_location_id"],
  ["dimension13", "selected_location_name"],
  ["dimension20", "user_id"],
  ["dimension21", "hue"],
  ["dimension23", "logged_in"],
  ["dimension24", "user_account_type"],
  ["dimension30", "ad_id"],
  ["dimension31", "ad_price"],
  ["dimension32", "ad_price_type"],
  ["dimension33", "ad_image_count"],
  ["dimension34", "ad_type"],
  ["dimension36", "ad_creation_date"],
  ["dimension38", "ad_description_length"],
  ["dimension40", "search_keyword"],
  ["dimension41", "onsite_search_results_page_number"],
  ["dimension42", "onsite_search_page_size"],
  ["dimension43", "onsite_search_total_results"],
  ["dimension44", "onsite_search_distance"],
  ["dimension45", "postal_code"],
  ["dimension47", "onsite_search_results_sort_type"],
  ["dimension48", "onsite_search_results_view_type"],
  ["dimension50", "click_source_domain"],
  ["dimension53", "click_campaign_parameters"],
  ["dimension73", "ad_blocker"],
  ["dimension88", "payment_provider"],
  ["dimension90", "l1_category_name"],
  ["dimension91", "l2_category_name"],
  ["dimension92", "l3_category_name"],
  ["dimension94", "l1_location_name"],
  ["dimension95", "l2_location_name"],
  ["dimension96", "l3_location_name"],
  ["dimension97", "l4_location_name"],
  ["dimension100", "onsite_search_min_price"],
  ["dimension101", "onsite_search_max_price"],
  ["dimension103", "ad_seller_type"],
  ["dimension104", "attribute_count"],
  ["dimension105", "search_type"],
  ["dimension108", "ad_attributes"],
  ["dimension109", "search_attributes"],
  ["dimension120", "ad_source"],
  ["dimension123", "feature_type"],
  ["dimension135", "adv_tg"],
  ["dimension136", "last_poster_type"],
  ["dimension142", "seller_score"],
  ["dimension144", "message_conversation_id"],
  ["dimension167", "s_dc"]
]);
function p(e) {
  const n = {};
  return Object.entries(e).forEach(([t, o]) => {
    o !== "" && (n[k.get(t) || t] = o);
  }), n;
}
const g = "trackingAttributes";
function E() {
  try {
    if (!localStorage)
      throw new Error("Local Storage not available");
    if (!localStorage.getItem(g))
      return {};
    const e = localStorage.getItem(g);
    return JSON.parse(e);
  } catch (e) {
    return console.error(e), {};
  }
}
function S(e, n) {
  const t = p(n), o = E();
  return {
    event: e,
    ...o,
    ...t
  };
}
function d(e, n) {
  const t = S(e, n);
  window.dataLayer.push(t);
}
function T(e) {
  try {
    localStorage.setItem(
      g,
      JSON.stringify(e)
    );
  } catch {
    console.error("Local Storage not available");
    return;
  }
}
function I(e) {
  const n = e && e.match(/ekConsentTcf2=({.*?});/);
  if (!n)
    return null;
  const t = decodeURIComponent(n[1]);
  let o;
  try {
    o = JSON.parse(t);
  } catch (a) {
    return window.RemoteJsLogging.logError(a, "GTM.getConsentInterpretation"), null;
  }
  return o.consentInterpretation;
}
function A() {
  const e = I(document.cookie);
  e && window.dataLayer && window.dataLayer.push({
    event: "consentInterpretationLoaded",
    consentInterpretation: e
  });
}
const L = /([\w-+.]+@[\w-.]+)/, f = /localhost|[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}|::1|\.local|^$/gi;
let l, w = {};
r() && !window.setLocalTrackDebugging && (window.setLocalTrackDebugging = D);
function i() {
  return typeof window < "u";
}
function r() {
  if (i())
    return f.lastIndex = 0, f.test(window.location.hostname);
}
function c(e, n) {
  console.log(
    `%c${e}`,
    "color: #0064D2; background-color: #E9E9E9; margin-bottom: 5px; padding: 5px; border-radius: 5px",
    JSON.stringify(
      { ...n, initialDimensions: w },
      null,
      "	"
    )
  );
}
function s() {
  let e;
  try {
    e = window.localStorage.getItem("setLocalTrackDebugging") === "true";
  } catch {
    e = !1;
  }
  return e;
}
function O() {
  try {
    Object.keys(window.localStorage).filter((n) => n.includes(l)).forEach((n) => {
      const t = h(
        JSON.parse(window.localStorage.getItem(n))
      );
      typeof t == "object" && Object.keys(t).length && d("gaEvent", {
        ...t,
        hitType: void 0
      }), window.localStorage.removeItem(n);
    });
  } catch (e) {
    console.error(e);
  }
}
function G(e, n, t = {}, o) {
  console.info(
    "initialize is being deprecated. initializeGoogleAnalytics(account, dimensionsObject) should be used instead."
  ), console.info(
    "the parameters userId and cookieDomain are not needed anymore.",
    n,
    o
  ), j(e, t);
}
function j(e, n = {}) {
  if (i()) {
    if (r()) {
      w = { ...n };
      return;
    }
    try {
      l = `${e}-eventqueue.`;
      const t = p(n);
      T(t), O(), A();
    } catch (t) {
      console.error("error while initializing kaGoogleAnalytics", t);
    }
  }
}
function C(e, n = {}) {
  if (!i())
    return;
  const o = (e || window.location.href).replace(L, "%removed%");
  if (r()) {
    s() && c("trackPageView", {
      url: o,
      fieldsObject: n
    });
    return;
  }
  d("page_meta", {
    page: o,
    ...n
  });
}
function z(e, n = {}) {
  if (!i())
    return;
  if (r()) {
    s() && c("trackDeferredEvent", {
      event: e,
      dimensionsObject: n
    });
    return;
  }
  if (!m(e))
    throw new Error("Event object in ek-google-analytics is invalid");
  if (!l)
    throw new Error(
      "ekGoogleAnalytics not initialized. You need to call ekGoogleAnalytics.initialize() first!"
    );
  const t = (/* @__PURE__ */ new Date()).getTime(), o = l + t, u = {
    data: `${e.eventCategory},${e.eventAction},${e.eventLabel || ""},${e.eventValue || ""}`,
    location: window.location.href,
    dimensions: n
  };
  try {
    window.localStorage.setItem(o, JSON.stringify(u));
  } catch {
    y(e);
  }
}
function P(e, n) {
  if (i()) {
    if (r()) {
      s() && c("trackEcommerceEvent", {
        event: e,
        ecommerce: n
      });
      return;
    }
    d(e, {
      ecommerce: n
    });
  }
}
function y(e, n = {}, t = {}) {
  if (i()) {
    if (r()) {
      s() && c("trackEvent", {
        event: e,
        fieldsObject: n,
        dimensionsObject: t
      });
      return;
    }
    if (!m(e))
      throw new Error("Event object in ek-google-analytics is invalid");
    d("gaEvent", {
      ...e,
      ...n,
      ...t
    });
  }
}
function x(e, n = {}, t = {}, o = 2e3) {
  if (i()) {
    if (r())
      return s() && c("trackEventWithTimeout", {
        event: e,
        fieldsObject: n,
        dimensionsObject: t
      }), Promise.resolve();
    if (!m(e))
      throw new Error("Event object in ka-google-analytics is invalid");
    return new Promise((a, u) => {
      const _ = setTimeout(a, o);
      n.eventCallback = (v) => {
        clearTimeout(_), a(v);
      }, y(e, n, t);
    });
  }
}
function D(e) {
  try {
    window.localStorage.setItem("setLocalTrackDebugging", e), console.log(
      `Debugging for local tracking is ${e ? "enabled" : "disabled"}.`
    );
  } catch {
    console.error("Local Storage not available.");
  }
}
export {
  b as eventStringToObject,
  G as initialize,
  j as initializeGoogleAnalytics,
  D as setLocalTrackDebugging,
  z as trackDeferredEvent,
  P as trackEcommerceEvent,
  y as trackEvent,
  x as trackEventWithTimeout,
  C as trackPageview
};
